import React from "react";
import MasterEdit from "../../../components/master/MasterEdit";

import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import axios from "axios";

const getSegmentAPI = `${process.env.REACT_APP_API_URL}api/segment`;

const MasterSegmentEdit = ({ buttonConfig, selectedItemId, isButtonClicked }) => {
  const schema = z.object({
    name: z.string().nonempty(),
    short_name: z.string().nonempty(),
    status: z.boolean().or(z.string()),
    eff_start_date: z.string().nonempty(),
    eff_end_date: z.string().nullable(),
  });

  const headers = {
    Authorization: `Bearer ${sessionStorage.getItem("subscriberToken")
    ? sessionStorage.getItem("subscriberToken")
    : sessionStorage.getItem("token")}`,
    "Content-Type": "application/json",
  };

  const form = useForm({
    defaultValues: async () => {
      const getSegment = `${getSegmentAPI}/${selectedItemId}`;
      const res = await axios.get(getSegment, { headers });
      const segment = res.data.data;
      return {
        name: segment.name,
        short_name: segment.short_name,
        status: segment.status ? "true" : "false",
        eff_start_date: segment.eff_start_date,
        eff_end_date: segment.eff_end_date,
      };
    },
    resolver: zodResolver(schema),
  });

  return (
    <MasterEdit
      segmentName="Segment"
      form={form}
      editHandler={buttonConfig.editHandler}
      closeHandler={buttonConfig.closeEditModal}
      selectedItemId={selectedItemId}
      shortNameRequired
      isButtonClicked={isButtonClicked}
    />
  );
};

export default MasterSegmentEdit;
